import React, { Component } from "react";
import styles from "./ImageMiniListItem.module.css";

export default class ImageMiniListItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { accountId } = this.props;
    const { id } = this.props.email;
    var ta = document.createElement("textarea");
    const url = `${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/images/${id}/image`;
    ta.value = url;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);

    if (this.props.onSelect) {
      this.props.onSelect(url);
    }
  }

  render() {
    const { id, name, updatedAt } = this.props.email;
    const { accountId } = this.props;

    return (
      <div className={styles.preview} onClick={this.handleClick}>
        <img
          src={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/images/${id}/image?updatedAt=${updatedAt}`}
          alt={name}
          title={name}
        />
      </div>
    );
  }
}
